import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from 'src/app/_shared/shared.module';
import { PeripheralConnectionEstablishModalComponent } from './peripheral-connection-establish-modal.component';
import { DataListModule } from '../data-list/data-list.module';

@NgModule({
    imports: [CommonModule, IonicModule, SharedModule, DataListModule],
    declarations: [PeripheralConnectionEstablishModalComponent],
    exports: [PeripheralConnectionEstablishModalComponent]
})
export class PeripheralConnectionEstablishModalModule {}
